import React from 'react';
import { CheckCircle2, Circle, FlaskConical, Loader, XCircle } from 'lucide-react';
import { btnPrimary } from '../aiModelUi';
import { StepProps } from './stepTypes';

const TestStep: React.FC<
  StepProps & {
    testing: boolean;
    onRunTest: () => void;
  }
> = ({ form, isLight, testing, onRunTest }) => {
  const result = form.lastTest;

  return (
    <div className="space-y-4">
      <p className={`text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
        Test is optional. It checks reachability, authentication, contracts, and a live prediction against the
        provider. You can register without running it.
      </p>
      <button type="button" onClick={onRunTest} disabled={testing} className={btnPrimary(testing)}>
        {testing ? <Loader size={14} className="animate-spin" /> : <FlaskConical size={14} />}
        {testing ? 'Testing…' : 'Run test'}
      </button>

      {result && (
        <div
          className={`rounded-lg border px-3 py-3 ${
            result.success
              ? isLight
                ? 'border-emerald-200 bg-emerald-50'
                : 'border-emerald-500/20 bg-emerald-500/10'
              : isLight
                ? 'border-amber-200 bg-amber-50'
                : 'border-amber-500/20 bg-amber-500/10'
          }`}
        >
          <div className={`text-xs font-semibold mb-2 ${isLight ? 'text-neutral-800' : 'text-white'}`}>
            {result.success ? 'All checks passed' : 'Some checks need attention'}
          </div>
          <ul className="space-y-1.5">
            {result.checks.map((check) => (
              <li key={check.id} className="flex items-start gap-2 text-xs">
                {check.passed ? (
                  <CheckCircle2 size={14} className="text-emerald-500 mt-0.5 shrink-0" />
                ) : (
                  <XCircle size={14} className="text-amber-500 mt-0.5 shrink-0" />
                )}
                <span className={isLight ? 'text-neutral-700' : 'text-gray-200'}>
                  {check.passed ? '✓ ' : ''}
                  {check.label}
                  {check.detail && (
                    <span className={`block text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
                      {check.detail}
                    </span>
                  )}
                </span>
              </li>
            ))}
          </ul>
          <p className={`text-[11px] mt-3 ${isLight ? 'text-neutral-600' : 'text-gray-300'}`}>
            Latency: {result.latencyMs} ms
          </p>
        </div>
      )}

      {!result && !testing && (
        <div className={`flex items-center gap-2 text-[11px] ${isLight ? 'text-neutral-400' : 'text-gray-500'}`}>
          <Circle size={12} /> No test run yet
        </div>
      )}
    </div>
  );
};

export default TestStep;
